import script from "./HeaderV2.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderV2.vue?vue&type=script&setup=true&lang=js"

import "./HeaderV2.vue?vue&type=style&index=0&id=a31da00c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a31da00c"]])

export default __exports__